module.exports = __webpack_public_path__ + "static/img/bottom.2c6119b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/door/bottom.png
// module id = usS4
// module chunks = 1